export default "__VITE_ASSET__DVBfRXUY__"